import getAddress from './getAddress';

export default ({ core, geocoding, action }) => {
  const { LatLng } = core || {};
  const { Geocoder } = geocoding || {};
  const t0 = Date.now();

  console.log('[GEO-DEBUG] getUserPosition called, hasLatLng:', !!LatLng, 'hasGeocoder:', !!Geocoder, 'hasAction:', !!action);

  const success = async (position) => {
    const { coords: { latitude, longitude } } = position;
    console.log('[GEO-DEBUG] getCurrentPosition SUCCESS:', latitude, longitude, '+' + (Date.now() - t0) + 'ms');
    if (LatLng && Geocoder) {
      try {
        const service = new Geocoder();
        const userLocation = new LatLng({ lat: latitude, lng: longitude });
        console.log('[GEO-DEBUG] calling geocode... +' + (Date.now() - t0) + 'ms');
        const data = await service.geocode({ location: new LatLng(userLocation) });
        console.log('[GEO-DEBUG] geocode response, results count:', data.results.length, '+' + (Date.now() - t0) + 'ms');
        const { results } = data;
        const [place] = results;
        const { address_components, geometry: { location, viewport } } = place;
        const addressComponents = address_components.map(ac => ({
          shortText: ac.short_name,
          longText: ac.long_name,
          types: ac.types,
        }));
        const address = getAddress(addressComponents);
        console.log('[GEO-DEBUG] calling action with address:', address, '+' + (Date.now() - t0) + 'ms');
        action({
          address,
          location,
          viewport,
        });
      } catch (geocodeErr) {
        console.log('[GEO-DEBUG] geocode FAILED:', geocodeErr, '+' + (Date.now() - t0) + 'ms');
        action({ error: geocodeErr });
      }
    } else {
      console.log('[GEO-DEBUG] no LatLng/Geocoder, calling action with raw coords');
      action({ latitude, longitude });
    }
  };

  const error = (e) => {
    console.log('[GEO-DEBUG] getCurrentPosition ERROR:', e.code, e.message, '+' + (Date.now() - t0) + 'ms');
    action({ error: e });
  };

  if (!navigator.geolocation) {
    console.log('[GEO-DEBUG] navigator.geolocation NOT available');
  } else {
    console.log('[GEO-DEBUG] calling getCurrentPosition... +' + (Date.now() - t0) + 'ms');
    navigator.geolocation.getCurrentPosition(success, error);
  }
};
